<template>
  <div class="landing-container">
    <HeroNew />
    <CompareYourself />
    <WorldForum />
    <LearningEconomy />
    <Steps1 />
    <QuantitiesSection />
    <Alumni />
    <FaqsNew />
    <CareerNew />
    <TryWorkeraNew />
    <FooterNew />
  </div>
</template>

<script>
import HeroNew from '~/components/landing-page/HeroNew'
import CompareYourself from '~/components/landing-page/CompareYourself'
import QuantitiesSection from '~/components/landing-page/QuantitiesSection'
import FooterNew from '~/components/global/FooterNew'
import Steps1 from '~/components/landing-page/Steps1'
import Alumni from '~/components/landing-page/Alumni'
import FaqsNew from '~/components/landing-page/FaqsNew'
import CareerNew from '~/components/landing-page/CareerNew'
import TryWorkeraNew from '~/components/landing-page/TryWorkeraNew'
import WorldForum from '~/components/landing-page/WorldForum'
import LearningEconomy from '~/components/landing-page/LearningEconomy'

export default {
  layout: 'landing',
  head() {
    return {
      title: 'Workera (a DeepLearning.AI company) | Precision upskilling',
      htmlAttrs: {
        lang: 'en',
      },
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content:
            'AI skills, AI jobs, AI careers, Jobs in AI, Data science skills/careers/jobs, Machine learning skills/careers/jobs',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'Workera is the skills transformation platform that helps organizations and individuals assess and develop their capabilities more effectively, initially focused on AI & Data. Workera’s mission is to help humanity achieve its fullest potential.',
        },
      ],
    }
  },
  components: {
    HeroNew,
    CompareYourself,
    QuantitiesSection,
    FooterNew,
    Steps1,
    Alumni,
    FaqsNew,
    CareerNew,
    TryWorkeraNew,
    WorldForum,
    LearningEconomy,
  },
  created() {
    console.log("%cWe're hiring engineers!", 'color: blue; font-size:20px')
    console.log('%cGo to https://workera.ai/careers/', 'font-size:20px')
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'Open Sans';
  src: url('https://fonts.googleapis.com/css?family=Assistant:400,600,700&display=swap');
}

.landing-container {
  font-family: Assistant;
}
</style>
